export const StatusColor = {
  online: '#57F287',
  idle: '#FEE75C',
  dnd: '#ED4245',
  offline: '#747f8d',
};

export const StatusName = {
  online: 'Disponivel',
  idle: 'Ausente',
  dnd: 'Não pertubar',
  offline: 'Invisivel',
};

export const BIRTH_DATE = new Date('2004-11-19T03:00:00.000Z');
